import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "textAlign", "variant", "htmlTag"];
import React from "react";
import Typography from "../../../../Typography";
import { BaseNumberTextCell } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function NumberCell(_ref) {
  var children = _ref.children,
    textAlign = _ref.textAlign,
    variant = _ref.variant,
    htmlTag = _ref.htmlTag,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseNumberTextCell, {
    children: /*#__PURE__*/_jsx(Typography, _extends({
      textAlign: "right",
      variant: "inherit"
    }, restProps, {
      children: children
    }))
  });
}
NumberCell.displayName = "NumberCell";
export default NumberCell;